// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import IconOverflowMenu from "@conklin/XDL/Icons/IconOverflowMenu";
import { color } from "@conklin/XDL/Utilities";
import { ComponentThemeProps } from "@insite/mobius/globals/baseTheme";
import { css } from "styled-components";

const OverflowMenuPresentationPropsDefault: ComponentThemeProps["overflowMenu"]["defaultProps"] = {
    buttonProps: {
        color: "common.white",
        shape: "pill",
        buttonType: "solid",
        shadow: false,
        css: css`
            background-color: transparent;
            border-color: transparent;
        `,
    },
    iconProps: { src: IconOverflowMenu, color: "common.ui9" },
};

export default OverflowMenuPresentationPropsDefault;
